import { partition } from "@ameelio/core";
import { useQuery } from "@apollo/client/react";
import { Stack } from "@mui/material";
import { TableSkeleton } from "../lib/closet.tsx";
import Screen from "../lib/Screen";
import AmeelioStaffTable from "./AmeelioStaffTable.tsx";
import { GetAmeelioStaffListDocument } from "./GetAmeelioStaffList.generated.ts";

export default function StaffManagementScreen() {
  const { data, loading } = useQuery(GetAmeelioStaffListDocument);
  const [activeStaff, inactiveStaff] = data
    ? partition(
        data.ameelioStaffList || [],
        (r) => r.__typename === "AmeelioStaff" && r.active
      )
    : [[], []];

  // TODO: use to conditionally allow invite email button
  // const admin = useIsAmeelioAdmin();

  return (
    <Screen title="Ameelio staff" maxWidth="md">
      <Stack spacing={2}>
        {data ? (
          <AmeelioStaffTable
            staff={activeStaff}
            deactivatedStaff={inactiveStaff}
            loading={loading}
          />
        ) : (
          <TableSkeleton />
        )}
      </Stack>
    </Screen>
  );
}
